import { render } from "./ExtAppForm.vue?vue&type=template&id=3487ea94"
import script from "./ExtAppForm.vue?vue&type=script&lang=js"
export * from "./ExtAppForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__